"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./MobileMegaMenu.scss");
var _generateLinks = require("../../utils/generateLinks");
var _rightCaretLightGray = _interopRequireDefault(require("../../images/right-caret-light-gray.svg"));
var _useOpenCategory = _interopRequireDefault(require("./useOpenCategory"));
var _useMouseSet = _interopRequireDefault(require("./useMouseSet"));
var _useFocus = require("../../utils/hooks/useFocus");
var _FeatureSection = require("../MegaMenu/menu-generators/FeatureSection");
var _MobileMegaMenuCategory = _interopRequireDefault(require("./MobileMegaMenuCategory"));
var _MobileMegaMenuPartialCategory = _interopRequireDefault(require("./MobileMegaMenuPartialCategory"));
var _MobileMegaMenuSubCategory = _interopRequireDefault(require("./MobileMegaMenuSubCategory"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
var _FocusedImage = _interopRequireDefault(require("../FocusedImage/FocusedImage"));
var _arrowDiagonalBlack = _interopRequireDefault(require("../../images/arrow-diagonal-black.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const MobileMegaMenu = props => {
  const {
    currentOpenMenu,
    isOpen,
    closeDropDown,
    megaMenuContent,
    links,
    featuredLinks,
    featuredLinksTitle,
    featuredPromoImage,
    featuredPromoPageLink,
    featuredPromoTitle,
    featuredPromoDescription,
    toggleDropDown,
    Link,
    hamburgerIsOpen
  } = props;
  const {
    openCategory,
    toggleCategory
  } = (0, _useOpenCategory.default)(isOpen);
  const {
    mouseSet
  } = (0, _useMouseSet.default)();

  //Sets references to collapsed and uncollapsed menus
  const [collapsedMenu, setCollapsedMenu] = (0, _useFocus.useFocus)();
  const [uncollapsedMenu, setUncollapsedMenu] = (0, _useFocus.useFocus)();
  const invisible = currentOpenMenu !== null;
  const generateSubmenu = () => {
    return links?.map((link, i) => {
      if (megaMenuContent?.type === "megaNav") {
        return /*#__PURE__*/_react.default.createElement(_MobileMegaMenuSubCategory.default, {
          key: `meganav-${i}-${megaMenuContent?.contentfulId}-${link?.contentfulId}`,
          links: link?.links,
          name: link?.title || link?.text,
          isOpen: openCategory === link.contentfulId,
          toggleCategory: toggleCategory,
          closeDropDown: closeDropDown,
          Link: Link,
          megaMenuContentText: megaMenuContent.text,
          parentOpen: isOpen && openCategory === null,
          categoryId: link?.contentfulId,
          subCategoryLink: link?.subCategoryLink,
          navType: megaMenuContent?.type
        });
      } else if (link?.links) {
        return /*#__PURE__*/_react.default.createElement(_MobileMegaMenuCategory.default, {
          key: `${megaMenuContent?.contentfulId}-${link.contentfulId}`,
          links: link.links,
          name: link.text,
          isOpen: openCategory === link.contentfulId,
          toggleCategory: toggleCategory,
          closeDropDown: closeDropDown,
          Link: Link,
          megaMenuContentText: megaMenuContent.text,
          parentOpen: isOpen && openCategory === null,
          categoryId: link?.contentfulId
        });
      } else {
        return /*#__PURE__*/_react.default.createElement(_MobileMegaMenuPartialCategory.default, {
          key: `${megaMenuContent?.contentfulId}-${link?.contentfulId}`,
          link: link,
          name: link?.text,
          isOpen: isOpen && openCategory === null,
          toggleCategory: toggleCategory,
          closeDropDown: closeDropDown,
          Link: Link
        });
      }
    });
  };
  const generateFeaturedPromoSection = () => {
    const content = {
      featuredLinksTitle,
      featuredLinks,
      featuredPromoDescription,
      featuredPromoImage,
      featuredPromoTitle,
      featuredPromoPageLink
    };
    const promoImageSizes = {
      desktop: {
        width: 250,
        height: 165,
        ratio: {
          width: 50,
          height: 33
        }
      },
      tablet: {
        width: 250,
        height: 165,
        ratio: {
          width: 50,
          height: 33
        }
      },
      mobile: {
        width: 250,
        height: 165,
        ratio: {
          width: 50,
          height: 33
        }
      }
    };
    const featureMenuProps = {
      content
    };
    if (content?.featuredLinks && content?.featuredLinks.length > 0 || featuredPromoPageLink) {
      return /*#__PURE__*/_react.default.createElement("section", {
        className: `ter-mobile-mega-menu-featured ${featuredPromoPageLink ? "ter-mobile-mega-menu-featured--promo" : ""} ${megaMenuContent?.type === "megaNav" ? ` ter-mobile-mega-menu-featured--meganav` : ``}`
      }, !featuredPromoPageLink && /*#__PURE__*/_react.default.createElement(_FeatureSection.FeatureSection, {
        featureProps: featureMenuProps
      }), featuredPromoPageLink && /*#__PURE__*/_react.default.createElement("div", {
        className: `ter-mobile-mega-menu-featured__promo`
      }, featuredPromoImage && /*#__PURE__*/_react.default.createElement("div", {
        className: "ter-mobile-mega-menu-featured__promo-image-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_FocusedImage.default, {
        focalPointImage: featuredPromoImage?.focalPointImage,
        imageSizes: promoImageSizes,
        alt: featuredPromoImage?.focalPointImage?.title
      })), /*#__PURE__*/_react.default.createElement("span", {
        className: `ter-mobile-mega-menu-featured__promo-title`
      }, featuredPromoTitle), /*#__PURE__*/_react.default.createElement("span", {
        className: `ter-mobile-mega-menu-featured__promo-description`
      }, featuredPromoDescription), featuredPromoPageLink?.url && /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
        to: featuredPromoPageLink?.url,
        target: featuredPromoPageLink?.external ? "_blank" : "_self",
        Link: Link,
        className: "ter-mobile-mega-menu-featured__promo-link"
      }, featuredPromoPageLink?.text, /*#__PURE__*/_react.default.createElement("img", {
        src: _arrowDiagonalBlack.default,
        alt: "external link",
        className: "ter-mobile-mega-menu-featured__promo-link-icon"
      }))));
    }
  };
  const toggleDropDownWithEnter = (event, id, direction) => {
    if (!mouseSet) {
      // checks that a user hits the enter key to open the modal
      if (event.keyCode === 13) {
        toggleDropDown(id);

        //accessbility - set the focus to the incoming menu
        if (direction === "open") {
          setCollapsedMenu();
        } else {
          setUncollapsedMenu();
        }
      }
    }
  };

  //determines reveal direction based on category states
  const getParentStyle = () => {
    let parentStyle = `ter-mobile-mega-menu ter-mobile-mega-menu--solo `;
    if (isOpen && openCategory === null) {
      parentStyle += "ter-mobile-mega-menu--reveal";
    } else if (isOpen && openCategory !== null) {
      parentStyle += "ter-mobile-mega-menu--reveal--from-left";
    } else {
      parentStyle += "ter-mobile-mega-menu--reveal--from-right";
    }
    return parentStyle;
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("section", {
    className: getParentStyle()
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: `ter-mobile-mega-menu__name ${isOpen ? "ter-mobile-mega-menu__name--open" : ""}`,
    tabIndex: mouseSet ? "" : "0",
    onClick: () => {
      toggleDropDown(megaMenuContent.contentfulId);
    },
    onKeyDown: e => toggleDropDownWithEnter(e, megaMenuContent.contentfulId, "open"),
    "aria-haspopup": "menu",
    "aria-expanded": isOpen,
    ref: uncollapsedMenu
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: `ter-mobile-mega-menu__caret ${isOpen ? "ter-mobile-mega-menu__caret--up" : "ter-mobile-mega-menu__caret--down"}`,
    src: _rightCaretLightGray.default,
    alt: "caret icon"
  }), megaMenuContent.text), /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-mobile-mega-menu__category-container ${isOpen ? "ter-mobile-mega-menu__category-container--is-open" : ""}`
  }, generateSubmenu(), generateFeaturedPromoSection(), megaMenuContent.bottomLink && (0, _generateLinks.generateSingleLink)(megaMenuContent?.bottomLink, "ter-mobile-mega-menu__bottom-link", closeDropDown, Link))), /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-mobile-mega-menu ${invisible ? "ter-mobile-mega-menu--inactive" : ""}`
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: `ter-mobile-mega-menu__name ${currentOpenMenu || !hamburgerIsOpen ? "" : "ter-mobile-mega-menu__name--open-parent"}`,
    "data-depth": 1,
    tabIndex: mouseSet ? "" : "0",
    onClick: () => {
      toggleDropDown(megaMenuContent?.contentfulId);
    },
    onKeyDown: e => toggleDropDownWithEnter(e, megaMenuContent?.contentfulId, "close"),
    "aria-expanded": !isOpen,
    ref: collapsedMenu
  }, megaMenuContent?.text, /*#__PURE__*/_react.default.createElement("img", {
    className: `ter-mobile-mega-menu__caret ${isOpen ? "ter-mobile-mega-menu__caret--up" : "ter-mobile-mega-menu__caret--down"}`,
    src: _rightCaretLightGray.default,
    alt: "caret icon"
  }))));
};
var _default = MobileMegaMenu;
exports.default = _default;